import { Flex, Divider, Box, Text, Tooltip, useTheme } from '@chakra-ui/react';
import { InfoIcon } from '../../../../icons';
import { WrongIcon } from '../../../../icons/WrongIcon';
import { KnowledgeArea } from '../../../../KnowledgeArea';
import { Fragment } from 'react';
import CommonLoadingCell from '../LoadingCell/CommonLoadingCell';
import type {
  KnowledgeAreaData,
  KnowledgeAreaRow,
  KnowledgeAreaItem,
} from '../../types/contributorTableTypes';

interface MetricState {
  metricTitle: string;
  metricKey: string;
  sequence: number;
}
type Props = {
  knowledgeArea?: KnowledgeAreaData;
  loading: boolean;
  selectedMetrics: MetricState[];
  rowHeight?: string;
};

const KnowledgeCol = ({
  knowledgeArea,
  loading,
  selectedMetrics,
  rowHeight,
}: Props) => {
  const { colors } = useTheme();
  return (
    <Flex
      direction="column"
      position="sticky"
      left={0}
      bg="white"
      h={'fit-content'}
      w="170px"
      zIndex={80}
    >
      <Flex
        bg="#FBFBFB"
        position="sticky"
        top={0}
        borderLeft="1px solid #E0E0E0"
        borderRight={
          selectedMetrics.length === 0 ? '1px solid #E0E0E0' : undefined
        }
        align="center"
        minH="52px"
        pl={4}
        pr={2}
        zIndex={50}
      >
        <Flex w="full" justify={'space-between'} align="center">
          <Text
            fontSize="sm"
            fontFamily="heading"
            fontWeight="medium"
            color="text.secondary2"
            w="180px"
          >
            Knowledge Area
          </Text>
          <Tooltip
            label={
              'Repositories the contributor has worked on, ranked by the percentage of development activity they have performed in each repository'
            }
            hasArrow
          >
            <Box>
              <InfoIcon width={17} height={17} />
            </Box>
          </Tooltip>
        </Flex>
      </Flex>

      <Divider />

      {loading
        ? [...Array(10)].map((_, index) => (
            <CommonLoadingCell key={index} rowHeight={rowHeight} />
          ))
        : knowledgeArea?.map((row: KnowledgeAreaRow | null, index: number) =>
            row ? (
              <Fragment key={`row-${index}`}>
                <Flex
                  direction="column"
                  justify={'center'}
                  minH={rowHeight || '110px'}
                  borderLeft="1px solid #E0E0E0"
                  borderRight={
                    selectedMetrics.length === 0
                      ? '1px solid #E0E0E0'
                      : undefined
                  }
                  p={3}
                  bg="white"
                >
                  <KnowledgeArea
                    knowledgeArea={row.map(
                      (
                        el: KnowledgeAreaItem
                      ): {
                        repo: string;
                        value: number;
                      } => ({
                        repo: el.name,
                        value: Math.round(Number(el.value ?? 0)),
                      })
                    )}
                    loading={loading}
                    showVertical
                    hideMore
                    fontFamily="heading"
                    fontSize="sm"
                    color="text.primary"
                  />
                </Flex>
                <Divider />
              </Fragment>
            ) : (
              <Fragment key={`row-${index}`}>
                <Flex
                  direction="column"
                  justify={'center'}
                  minH={rowHeight || '110px'}
                  borderLeft="1px solid #E0E0E0"
                  borderRight={
                    selectedMetrics.length === 0
                      ? '1px solid #E0E0E0'
                      : undefined
                  }
                  p={3}
                  bg="white"
                >
                  <Flex justify={'center'} align={'center'} gap={1}>
                    <Box mt={2} mr={-2}>
                      <WrongIcon
                        color={'transparent'}
                        stroke={colors.error}
                        height={23}
                        width={23}
                      />
                    </Box>
                    <Text
                      fontSize="sm"
                      color="text.primary"
                      fontWeight={'medium'}
                    >
                      No Data Available
                    </Text>
                  </Flex>{' '}
                </Flex>
                <Divider />
              </Fragment>
            )
          )}
    </Flex>
  );
};

export default KnowledgeCol;
